export const FETCH_ACCOUNTS_REQUEST = 'ACCOUNTS/FETCH_ACCOUNTS_REQUEST';
export const FETCH_ACCOUNTS_SUCCESS = 'ACCOUNTS/FETCH_ACCOUNTS_SUCCESS';
export const FETCH_ACCOUNTS_FAILURE = 'ACCOUNTS/FETCH_ACCOUNTS_FAILURE';
